<template>
  <div>
    <!-- 红字发票查看 -->
    <el-dialog v-model="open" @open="openDialog">
      <div class="dialog-body">
        <p style="font-size: 14px; font-weight: 600; color: #333">详细信息</p>
        <p style="font-size: 14px; font-weight: 600; color: #333; margin-top: 15px">
          红字发票信息确认单状态：{{ getQuerenStatus(props.row.isQueren) }}
        </p>
        <p style="font-size: 14px; font-weight: 600; color: #333; margin-top: 15px">已实际抵扣税额（元）：0.00 已加计抵扣进项税额（元）：0.00</p>
        <p style="font-size: 14px; font-weight: 600; color: #333; margin-top: 15px">已选发票</p>
        <div class="box-line">
          <p style="font-size: 14px; font-weight: 600; color: #333">
            票面金额：{{ Number(props.row.totalAddedTaxAmount || 0).toFixed(2) }} <span style="margin: 0 10px; color: #ddd">|</span> 数电票号码
            {{ props.row.code }}
          </p>

          <el-row style="margin-top: 10px">
            <el-col :span="5">
              <p style="font-size: 14px; color: #666; margin-top: 10px">(销售方)纳税人名称</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">
                {{ props.row.seller?.name }}
              </p>
              <p style="font-size: 14px; color: #666; margin-top: 20px">开票日期</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">
                {{ props.row.createTime }}
              </p>
            </el-col>
            <el-col :span="7">
              <p style="font-size: 14px; color: #666; margin-top: 10px">(销售方)统一社会信用代码/纳税人识别号</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">
                {{ props.row.seller?.taxRegistrationNo }}
              </p>
              <p style="font-size: 14px; color: #666; margin-top: 20px">增值税用途状态</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">未勾选</p>
            </el-col>
            <el-col :span="5">
              <p style="font-size: 14px; color: #666; margin-top: 10px">(购买方)纳税人名称</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">
                {{ props.row.buyer?.name }}
              </p>
              <p style="font-size: 14px; color: #666; margin-top: 20px">消费税用途状态</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">未勾选</p>
            </el-col>
            <el-col :span="7">
              <p style="font-size: 14px; color: #666; margin-top: 10px">(购买方)统一社会信用代码/纳税人识别号</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">
                {{ props.row.buyer?.taxRegistrationNo }}
              </p>
              <p style="font-size: 14px; color: #666; margin-top: 20px">入账状态</p>
              <p style="font-size: 14px; color: #666; margin-top: 10px">未入账</p>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 20px">
          <p class="font14 cor333" style="font-size: 14px; color: #333">开具红字发票原因</p>
          <el-select v-model="props.row.checker" :disabled="true" style="width: 300px; margin-top: 10px">
            <el-option label="开票有误" value="1" />
            <el-option label="服务中止" value="2" />
            <el-option label="销货退回" value="3" />
            <el-option label="销售折让" value="4" />
          </el-select>
        </div>

        <div class="table-wrap">
          <el-table :data="props.row.items" :border="true">
            <el-table-column label="项目名称" prop="name" />
            <el-table-column label="规格型号" prop="specification" align="center" />
            <el-table-column label="单位" prop="unit" align="center" />
            <el-table-column label="数量" prop="count" align="center" />
            <el-table-column :label="`单价${props.row.addedTax ? '（含税）' : '（不含税）'}`" prop="price" align="center" />
            <el-table-column :label="`金额${props.row.addedTax ? '（含税）' : '（不含税）'}`" prop="amount" align="center">
              <template #default="{ row }">
                <span style="color: red">{{ row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="税率/征收率" prop="rate" align="center">
              <template #default="{ row }">
                <span>{{ row.rate * 100 + '%' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="税额" prop="taxAmount" align="center" />
            <template #append>
              <div
                style="
                  box-sizing: border-box;
                  width: 100%;
                  height: 50px;
                  padding: 0 8px;
                  line-height: 50px;
                  border-bottom: 1px solid #ddd;
                  display: flex;
                "
              >
                <p style="width: 20%">合计</p>
                <p style="width: 60%; text-align: end">￥{{ props.row.totalAmount }}</p>
                <p style="width: 20%; text-align: end">￥{{ props.row.totalTaxAmount }}</p>
              </div>
              <div
                style="
                  box-sizing: border-box;
                  width: 100%;
                  height: 50px;
                  padding: 0 8px;
                  line-height: 50px;
                  border-bottom: 1px solid #ddd;
                  display: flex;
                "
              >
                <p style="width: 80%; text-align: end; font-weight: 700">价税合计(大写): ⊗{{ props.row.payee }}</p>
                <p style="width: 20%; text-align: end; font-weight: 700">价税合计(小写)：{{ props.row.totalAddedTaxAmount }}</p>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <template #footer>
        <el-button type="default" @click="open = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
const props = defineProps({
  row: {
    type: Object,
    default: () => ({}),
  },
});

const open = defineModel({ type: Boolean, default: false });

function openDialog() {
  console.log(props.row);
}

//获取冲红
function getQuerenStatus(cellValue) {
  let str = '';
  const mapList = [
    { label: '无需确认', value: '1' },
    { label: '购方录入待销方确认', value: '4' },
    { label: '购销双方已确认', value: '2' },
    { label: '作废', value: '6' },
    { label: '销方录入待购方确认', value: '99' },
  ];
  mapList.forEach((item) => {
    if (item.value == cellValue) {
      str = item.label;
    }
  });
  return str;
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  width: 80vw;
  .el-dialog__body {
    .dialog-body {
      .box-line {
        box-sizing: border-box;
        width: 100%;
        padding: 20px;
        margin-top: 20px;
        border: 1px solid #eee;
        border-radius: 4px;
      }
      .table-wrap {
        width: 100%;
        min-height: 120px;
        height: calc(86vh - 530px);
        margin-top: 20px;
        overflow-x: auto;
      }
    }
  }
}
</style>
